<div class=" row mt-3 " style="padding: 10px;">
                         
                          
    <div class="col-md-12 " >
      <div class=" col-md-12 row">
      <mat-form-field class=" col-md-3 mt-1 form-group " >
      <input matInput type="text"     placeholder="Search..." [(ngModel)]="searchText" (input)="searchFilter()" autocomplete="off"   >
      
      </mat-form-field>
      <div class="col-md-1 mt-3 ">
     <div class="col-md-12 d-flex justify-content-end">
        <button  class="btn btn-outline-primary btn-sm " (click)="onAddMile()">
            <img src="assets/images/Add_24.png"></button>
    </div>
      </div>
      <mat-paginator  class="col-md-8 mt-2 " style="background-color: transparent;" color="primary"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 100]"
      [length]="totalElements"
      (page)="nextPage($event)"
      aria-label="Select page">
      </mat-paginator>
      
      </div>
      <div class="col-md-12" style="overflow: auto ;max-height:50vh;">
      <table mat-table 
      [dataSource]="mealData" multiTemplateDataRows style="background-color: transparent;">
     
     
       <ng-container matColumnDef="formAirport">
         <th mat-header-cell *matHeaderCellDef>From Airport</th>
         <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowMileClick(element)"> {{element.fromAirport}} </td>
       </ng-container>
      <ng-container matColumnDef="toAirport">
       <th mat-header-cell *matHeaderCellDef> To Airport </th>
       <td mat-cell *matCellDef="let element"> 
          {{sourceName(element?.toAirport)||''}}
         </td>
      </ng-container>
      
     
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef>Value</th>
        <td mat-cell *matCellDef="let element"> {{element?.value+element?.unit}} </td>
       </ng-container>
       <ng-container  matColumnDef="carrierName">
        <th mat-header-cell *matHeaderCellDef>Carrier Name</th>
        <td mat-cell *matCellDef="let element">
          {{element?.carrierName}}
           <!-- <button style="background-color: #3389fa;color: white;margin: 4px; " mat-flat-button >GST Detail</button> -->
        </td>
       </ng-container>
     
      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container  matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsMilesDisplay.length">
      <div class="example-element-detail row"
       [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
      
      </div>
      </td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="columnsMilesDisplay;sticky" style="background-color: white;"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsMilesDisplay;"
      class="example-element-row">
      </tr>
      <tr  mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      <tr class="mat-row" *matNoDataRow>
      <td  class="mat-cell" colspan="4">There is no data in this table</td>
      </tr>
      </table>
      
    </div>
      </div>
      
  

</div> 

<div class="modal "  id="myMod"  [style.display]="showMilePopup ? 'block' : 'none'" >
    <div class="modal-dialog" >
        <div class="modal-content " >
            <div class="modal-header title" *ngIf="showMilePopup">
              <h4 *ngIf="action==='new'"  class="modal-title">Add Mile</h4>
              <h4 *ngIf="action==='update'"  class="modal-title">Edit Mile</h4>


            <button *ngIf="!selectedFile && action==='new'" type="button" mat-raised-button (click)="fileInput.click()">Select File</button>
            <button *ngIf="selectedFile && action==='new'" type="button" mat-raised-button (click)="fileInput.click()">{{selectedFile?.name}}</button>

            <input    hidden  accept=".xlsx, .xls" (change)="onFileSelected($event)" #fileInput type="file"> 
            <button *ngIf="action==='new'"  class="btn btn-outline-success c-width-100px shadow " (click)="uploadFile()"  [disabled]="!fileSelected">Bulk Upload</button>





              <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
              </div>
              <div class="modal-body">
              <div class="col-md-12 mt-3 " *ngIf="showMilePopup">
                <div class="col-md-12 d-flex justify-content-center" >
                <div class="col-md-12 row " >
                    <div class=" col-md-12 " >
                            <form [formGroup]="mileRegFg"   autocomplete="off"  class=" row" >
                                
                               
                                
                                <mat-form-field class="col-md-6" appearance="outline">
                                  <mat-label>From Airport</mat-label>
                                  
                                  <input matInput type="text" formControlName="fromAirport" name="fromAirport" autocomplete="off">
                                  <small *ngIf="mileRegFg.controls['fromAirport'].dirty && mileRegFg.controls['fromAirport'].invalid" class="warn">Please Enter From Airport!</small>

                          
                                </mat-form-field>  
                                <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>To Airport</mat-label>
                                    
                                    <input matInput type="text" formControlName="toAirport" name="toAirport" autocomplete="off">
                                    <small *ngIf="mileRegFg.controls['toAirport'].dirty && mileRegFg.controls['toAirport'].invalid" class="warn">Please Enter To Airport!</small>
  
                            
                                  </mat-form-field>  
                                 
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Unit</mat-label>
                                    <mat-select formControlName="unit" name="unit">
                                      <mat-option value="km">KM</mat-option>
                                      <mat-option value="miles">Miles</mat-option>

                                    </mat-select>

                                   
                                  </mat-form-field>  
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>value</mat-label>
                                    
                                    <input matInput type="text" (keypress)="onlyNumberKey($event)"  formControlName="value" name="value" autocomplete="off">
                                    <small *ngIf="mileRegFg.controls['value'].dirty && mileRegFg.controls['value'].invalid" class="warn">Please Enter Value!</small>
  
                            
                                  </mat-form-field>  
                                
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Carrier Code</mat-label>
                                    <mat-select matNativeControl name="carrierCode" formControlName="carrierName">
                                      <mat-option *ngFor="let item of carrierCodeList" [value]='item.airlineDesignatorCode'>{{item.carrierName}}</mat-option>
  
                                    </mat-select> 
  
                                  </mat-form-field>
                                
                                

                                </form>
                    </div>
                    </div>
                    </div>                                      
              </div>
                <div class="modal-footer">
                  <div class="form-group form-inline ">
                    <label for="gstlabel" class="col-md-5 col-form-label control-label"> </label>
                  </div>   
                  <button *ngIf="action==='update'"  class="btn btn-outline-success c-width-100px shadow " (click)="AddMile()" [disabled]="mileRegFg.invalid" >Update</button>

                  <button *ngIf="action==='new'"  class="btn btn-outline-success c-width-100px shadow " (click)="AddMile()" [disabled]="mileRegFg.invalid" >Save</button>
                  <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                </div>
              </div>
              </div>
      </div>
  </div>